<template>
  <div class="w-full sm:max-w-368 px-16 sm:px-0">
    <router-view :isEdit="isEdit" :sitterProfile="sitterProfile"><slot /></router-view>
  </div>
</template>

<script lang="ts">
export default {
  name: 'Availability',
  props: {
    sitterProfile: {
      default: () => {},
      type: Object,
    },
    isEdit: {
      default: false,
      type: Boolean,
    },
  },
};
</script>
